module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":{"label":"Name","placeholder":"Enter name"},"username":{"label":"Username","placeholder":"Enter username"},"password":{"label":"Password","placeholder":"Enter password"}},"id":{"name":{"label":"Nama","placeholder":"Nama Member"},"username":{"label":"Username","placeholder":"Enter username"},"password":{"label":"Password","placeholder":"Enter password"}}}')
  delete Component.options._Ctor
}
